//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
import "../Motion/Motion.ControlInputPortBuilderList.js";
import "../no/ObjectList.js";
let d=[[[0,"Name",1,0],[1,"PortsList",0,"Motion.ControlInputPortBuilderList",0],[0,"SinglePort",0,"Motion.ControlInputPortBuilder",0]],[[[],"CreateControlInputPortBuilder",{R_:{portBuilder:"Motion.ControlInputPortBuilder"}},0,0]],[]];
SPLM.Motion.ControlInputBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ControlInputBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.ControlInputBuilder.FunctionCurveType = Object.freeze({
    "Polynomial" : "Polynomial", "Harmonic" : "Harmonic", "Function" : "Function", "Profile2D" : "Profile2D", "Step" : "Step", "Ramp" : "Ramp"});

SPLM.Motion.ControlInputBuilder.PathFollowerElmentType = Object.freeze({
    "Function" : "Function", "Profile2D" : "Profile2D", "Road" : "Road"});

SPLM.Motion.ControlInputBuilder.PathFollowerLookAheadDistanceType = Object.freeze({
    "Expression" : "Expression", "FromPort" : "FromPort"});

SPLM.Motion.ControlInputBuilder.SpecialControlRefernceNumberType = Object.freeze({
    "Extra" : "Extra", "Lambda" : "Lambda", "ElementData" : "ElementData"});

SPLM.Motion.ControlInputBuilder.SpecialControlElementType = Object.freeze({
    "MotionObject" : "MotionObject", "Function" : "Function"});

export default SPLM;